import { ProtectionType } from "../entities";

/**
 *
 * Maps protection type to selective numeric value from 0 to 2 :
 * - 0 -> Standard protection
 * - 1 -> Password protection
 * - 2 -> Recipient authentication
 *
 * @param protectionType current protection type set by the user.
 * @returns 0 or 1 or 2 depending on protection type.
 */
function mapProtectionTypeToNumber(protectionType?: ProtectionType): 0 | 1 | 2 {
  switch (protectionType) {
    case ProtectionType.password:
      return 1;
    case ProtectionType.recipientAuthentication:
      return 2;
    default:
      return 0;
  }
}

export { mapProtectionTypeToNumber };
